import { render, staticRenderFns } from "./resourceMobileEdit.vue?vue&type=template&id=129b8f5a&scoped=true&"
import script from "./resourceMobileEdit.vue?vue&type=script&lang=js&"
export * from "./resourceMobileEdit.vue?vue&type=script&lang=js&"
import style0 from "./resourceMobileEdit.vue?vue&type=style&index=0&id=129b8f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129b8f5a",
  null
  
)

export default component.exports